import { useEffect, useState } from "react";
import ArcGisMap from "../Map";
import { getPathFromGeometry, getPolygon } from "../Map/helper";
import {TGeometry, TNullable} from "../../../common/types/common";
import MapView from "@arcgis/core/views/MapView";

interface Props {
    geometry?: TGeometry,
    path?: TGeometry | null;
}

const ReadOnlyMap = ({ geometry, path = undefined }: Props) => {
    const [view, setView] = useState<TNullable<MapView>>(null);

    const onMapInit = ({ view }) => {
        setView(view);
    };

    useEffect(() => {
        if (view) {
            const polygon = geometry ? getPolygon(geometry) : null;
            if (polygon) {
                view.graphics.add(polygon);
            }

            const line = path ? getPathFromGeometry(path) : null;
            if (line) {
                view.graphics.add(line);
            }

            view.when(() => { // View is ready now
                view.goTo({ center: [polygon ?? line ?? null] }).catch(() => { 
                    console.log('Map goTo aborted.'); // prevents goto interruption error
                });
            });
        }
    }, [view, geometry, path]);

    return <ArcGisMap onInit={onMapInit} />;
};

export default ReadOnlyMap;
